/**
 * 全局配置信息 
 */
export class AppConfig {
    //是否Debug的标志位 
    public static isDebug(): boolean {
        return true;
    }

    //服务器接口URL
    public static getServerUrl(): string {
        return "http://36.112.129.26/emrapi/api/public/";
    }

    //获取版本号 
    public static getVersionNo() {
        return "1.0.0";
    }
}